/**
 * DEV-268 — a mensagem de convite do diálogo "Compartilhar formulário" (AC-07)
 * e o link do formulário (AC-08, D1). Funções PURAS: o texto é literal do card
 * e o link é a origem do APP Consultor em uso + o `path` que o backend devolve
 * (`/descricao-vaga/{tenant}/{formId}`).
 */

export interface AlignmentInviteInput {
  programName: string;
  link: string;
  token: string;
}

/** `https://consultor.eureca.me` + `/descricao-vaga/acme/<formId>` → link completo. */
export function buildAlignmentFormLink(origin: string, path: string): string {
  const base = origin.replace(/\/+$/, '');
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${base}${suffix}`;
}

/**
 * AC-07 — parágrafo, linha em branco, `Link:` e `Token:`. Sem truncamento:
 * é o texto que vai ao clipboard (AC-09).
 */
export function buildAlignmentInviteMessage(input: AlignmentInviteInput): string {
  return [
    `Olá! Você recebeu um convite para dar mais detalhes sobre as vagas do Programa ${input.programName} para a nossa equipe de consultoria. Acesse o link a seguir e use o token informado.`,
    '',
    `Link: ${input.link}`,
    `Token: ${input.token}`,
  ].join('\n');
}
